import AnchorLink from 'react-anchor-link-smooth-scroll'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import React from 'react'
import PropTypes from 'prop-types'
import { Navbar, Nav, NavItem, NavDropdown, MenuItem } from 'react-bootstrap'

import './index-sass/index.scss'
import '../../static/fonts/fontawesome/css/fontawesome-all.min.css'  // FontAwesome5 https://fontawesome.com/icons?m=free

/**
 * Wrapper that contains children
 * NOTE: we are passing imageStore to all children as a properties,
 *  so that they can render images via `gatsby-images`
 */
class TemplateWrapper extends React.Component {
  render() {
    // PREPARE IMAGE STORE
    //  we pass props to children see https://github.com/gatsbyjs/gatsby/issues/3412
    const {
      activeCampaignLogoImage,
      blazeLogoImage,
      businessModellierungImage,
      chaijsMochaImage,
      chimpLogoImage,
      circleciLogoImage,
      digitaloceanLogoImage,
      expressLogoImage,
      expressLogoResolutionsImage,
      gatsbyStaticSiteLogoImage,
      googleAnalyticsIconImage,
      herokuLogoImage,
      htmlCssLogosImage,
      javaLogoImage,
      jsIconImage,
      leanStartupImage,
      meteorJsIconImage,
      meteorJsWebapplikationImage,
      meteorLogoImage,
      meteorLogoResolutionsImage,
      mixpanelLogoImage,
      mongoLogoImage,
      nodeJsLogoImage,
      npmLogImage,
      phpLogoImage,
      profilbildHzImage,
      prototypeIconImage,
      pythonDjangoLogoImage,
      reactLogoImage,
      reactLogoWordmarkImage,
      segmentioImage,
      tddDiagramImage,
      teamPilotImage,
      teampilotScreenshotImage,
      theLeanStartupImage,
      toolsImage,
      userExperienceLogoImage,
      wireframingIconImage,
      wordpressLogoImage,
    } = this.props.data
    const imageStore = {
      activeCampaignLogoImage,
      blazeLogoImage,
      businessModellierungImage,
      chaijsMochaImage,
      chimpLogoImage,
      circleciLogoImage,
      digitaloceanLogoImage,
      expressLogoImage,
      expressLogoResolutionsImage,
      gatsbyStaticSiteLogoImage,
      googleAnalyticsIconImage,
      herokuLogoImage,
      htmlCssLogosImage,
      javaLogoImage,
      jsIconImage,
      leanStartupImage,
      meteorJsIconImage,
      meteorJsWebapplikationImage,
      meteorLogoImage,
      meteorLogoResolutionsImage,
      mixpanelLogoImage,
      mongoLogoImage,
      nodeJsLogoImage,
      npmLogImage,
      phpLogoImage,
      profilbildHzImage,
      prototypeIconImage,
      pythonDjangoLogoImage,
      reactLogoImage,
      reactLogoWordmarkImage,
      segmentioImage,
      tddDiagramImage,
      teamPilotImage,
      teampilotScreenshotImage,
      theLeanStartupImage,
      toolsImage,
      userExperienceLogoImage,
      wireframingIconImage,
      wordpressLogoImage,
    }
    return (
      <div>
        <Helmet>
          {/* Google Search Console */}
          <meta name="google-site-verification" content="GpTueMnBXxnwt2p9J8DCbShQcKoNYfZnnx4_8bL0oYk"/>
          {/* Favicon */}
          <link rel="apple-touch-icon" sizes="57x57" href="/images/apple-icon-57x57.png"/>
          <link rel="apple-touch-icon" sizes="60x60" href="/images/apple-icon-60x60.png"/>
          <link rel="apple-touch-icon" sizes="72x72" href="/images/apple-icon-72x72.png"/>
          <link rel="apple-touch-icon" sizes="76x76" href="/images/apple-icon-76x76.png"/>
          <link rel="apple-touch-icon" sizes="114x114" href="/images/apple-icon-114x114.png"/>
          <link rel="apple-touch-icon" sizes="120x120" href="/images/apple-icon-120x120.png"/>
          <link rel="apple-touch-icon" sizes="144x144" href="/images/apple-icon-144x144.png"/>
          <link rel="apple-touch-icon" sizes="152x152" href="/images/apple-icon-152x152.png"/>
          <link rel="apple-touch-icon" sizes="180x180" href="/images/apple-icon-180x180.png"/>
          <link rel="icon" type="image/png" sizes="192x192"  href="/images/android-icon-192x192.png"/>
          <link rel="icon" type="image/png" sizes="32x32" href="/images/favicon-32x32.png"/>
          <link rel="icon" type="image/png" sizes="96x96" href="/images/favicon-96x96.png"/>
          <link rel="icon" type="image/png" sizes="16x16" href="/images/favicon-16x16.png"/>
          <meta name="msapplication-TileColor" content="#ffffff"/>
          <meta name="msapplication-TileImage" content="/images/ms-icon-144x144.png"/>
        </Helmet>
        <header role="banner" id="fh5co-header">
          <div className="container">
            <Navbar id="navbar" collapseOnSelect>
              <Navbar.Header>
                <Navbar.Brand>
                  <Link to="/">Software&shy;piloten</Link>
                </Navbar.Brand>
                <Navbar.Toggle />
              </Navbar.Header>
              <Navbar.Collapse>
                <Nav pullRight>
                  <NavItem eventKey={1} href="/unsere-staerken">
                    Unsere Stärken
                  </NavItem>
                  {/* TODO FIX throws error */}
                  <li><AnchorLink className="btn btn-primary" href="#contact">Kontakt</AnchorLink></li>
                  <NavItem eventKey={3} href="/en" title="Let's talk in english!">
                    <i className="fas fa-globe"></i>
                  </NavItem>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </header>
        <div>
          {this.props.children({ ...this.props, imageStore })}
        </div>
        <footer>
          <div className="container">
            <div className="row">
              <div className="footerBox col-md-4">
                <p><i>Impressum</i></p>
                <p>
                  Softwarepiloten UG
                  <br/>Moltkestrasse 25
                  <br/>42799 Leichlingen (Rheinland)
                </p>
              </div>
              <div className="footerBox col-md-4">
                <ul className="neutral-list">
                  <li><Link to="/impressum">Impressum</Link></li>
                  <li><Link to="/datenschutz-erklaerung">Datenschutz Erklärung</Link></li>
                  <li><Link to="/meteor">Meteor.Js Framework</Link></li>
                  <li><Link to="/meteor/meteor-entwickler">Meteor Entwickler</Link></li>
                  <li><Link to="/meteor/meteor-freelancer">Meteor Freelancer</Link></li>
                  <li><Link to="/meteor/meteor-programmierer-koeln">Meteor Programmierer Köln</Link></li>
                  <li><Link to="/meteor/meteor-programmierer-duesseldorf">Meteor Programmierer Düsseldorf</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </div>
    )
  }
}

export default TemplateWrapper

// IMAGE-STORE QUERY
// Idea: Here we have CENTRAL place to load images for `gatsby-images`
// NOTE that we need to MIRROR the `imageStore`-variable in the above code!!!
// BACKGROUND:
//  * Gatsby's Components (placed under `/src/components/*`)
//     can NOT run their own GraphQl-queries, so we need to pass them
//     into the component via props.
export const pageQuery = graphql`
  query ImageStoreQuery {
    teamPilotImage: imageSharp(id: { regex: "/teampilot-screenshot.png/" }) {
      sizes(maxWidth: 360) {
        ...GatsbyImageSharpSizes
      }
    },
    profilbildHzImage: imageSharp(id: { regex: "/profilbild-hz.jpg/" }) {
      sizes(maxWidth: 304) {
        ...GatsbyImageSharpSizes
      }
    },
    leanStartupImage: imageSharp(id: { regex: "/lean-startup.png/" }) {
      sizes(maxWidth: 304) {
        ...GatsbyImageSharpSizes
      }
    },
    npmLogImage: imageSharp(id: { regex: "/640px-Npm-logo.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    activeCampaignLogoImage: imageSharp(id: { regex: "/active-campaign-logo.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    blazeLogoImage: imageSharp(id: { regex: "/blaze-logo.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    businessModellierungImage: imageSharp(id: { regex: "/business-modellierung.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    chaijsMochaImage: imageSharp(id: { regex: "/chaijs-mocha.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    chimpLogoImage: imageSharp(id: { regex: "/chimp-logo.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    circleciLogoImage: imageSharp(id: { regex: "/circleci-logo.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    digitaloceanLogoImage: imageSharp(id: { regex: "/digitalocean-logo.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    expressLogoImage: imageSharp(id: { regex: "/express-logo.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    expressLogoResolutionsImage: imageSharp(id: { regex: "/express-logo.png/" }) {
      resolutions(width: 465) {
        ...GatsbyImageSharpResolutions
      }
    },
    gatsbyStaticSiteLogoImage: imageSharp(id: { regex: "/gatsby-static-site-logo.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    googleAnalyticsIconImage: imageSharp(id: { regex: "/google-analytics-icon.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    herokuLogoImage: imageSharp(id: { regex: "/heroku-logo.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    htmlCssLogosImage: imageSharp(id: { regex: "/html-css-logos.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    javaLogoImage: imageSharp(id: { regex: "/java-logo.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    jsIconImage: imageSharp(id: { regex: "/js-icon.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    meteorJsIconImage: imageSharp(id: { regex: "/meteor-js-icon.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    meteorJsWebapplikationImage: imageSharp(id: { regex: "/meteor-js-webapplikation.jpg/" }) {
      sizes(maxWidth: 2000) {
        ...GatsbyImageSharpSizes
      }
    },
    meteorLogoImage: imageSharp(id: { regex: "/meteor-logo.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    meteorLogoResolutionsImage: imageSharp(id: { regex: "/meteor-logo.png/" }) {
      resolutions(width: 270) {
        ...GatsbyImageSharpResolutions
      }
    },
    mixpanelLogoImage: imageSharp(id: { regex: "/mixpanel-logo.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    mongoLogoImage: imageSharp(id: { regex: "/mongo-logo.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    nodeJsLogoImage: imageSharp(id: { regex: "/node-js-logo.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    phpLogoImage: imageSharp(id: { regex: "/php-logo.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    prototypeIconImage: imageSharp(id: { regex: "/prototype-icon.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    pythonDjangoLogoImage: imageSharp(id: { regex: "/python-django-logo.jpg/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    reactLogoWordmarkImage: imageSharp(id: { regex: "/react_logo_wordmark.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    reactLogoImage: imageSharp(id: { regex: "/react-logo.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    segmentioImage: imageSharp(id: { regex: "/segmentio.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    tddDiagramImage: imageSharp(id: { regex: "/TDD-diagram_02.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    teampilotScreenshotImage: imageSharp(id: { regex: "/teampilot-screenshot.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    theLeanStartupImage: imageSharp(id: { regex: "/The-Lean-Startup.jpg/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    toolsImage: imageSharp(id: { regex: "/tools-meteor-express-node-react-tdd.png/" }) {
      sizes(maxWidth: 1200) {
        ...GatsbyImageSharpSizes
      }
    },
    userExperienceLogoImage: imageSharp(id: { regex: "/user-experience-logo.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    wireframingIconImage: imageSharp(id: { regex: "/wireframing-icon.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
    wordpressLogoImage: imageSharp(id: { regex: "/wordpress-logo.png/" }) {
      sizes(maxWidth: 120) {
        ...GatsbyImageSharpSizes
      }
    },
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js